import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { put } from '../../../utility/fetch';

const CommunitySearch = ({ data }) => {

    // Tab state: joined, created, friends, or discover
    const [activeTab, setActiveTab] = useState("joined");
    // Search state (shared across views for demo purposes)
    const [searchQuery, setSearchQuery] = useState("");
    const [groupLoading, setGroupLoading] = useState(false);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const groups = [
        { name: "Plant Remedy", image: "/user-avater.png" },
        { name: "Fitness & Wellness", image: "/user-avater.png" },
        { name: "Autism", image: "/user-avater.png" },
        { name: "All About Your Health, Nursing And Midwifery", image: "/user-avater.png" },
        { name: "Mental Health Initiatives", image: "/user-avater.png" },
        { name: "Skin Care & Beauty Trend", image: "/user-avater.png" },
        { name: "Body Type", image: "/user-avater.png" },
        { name: "Fitness Journey", image: "/user-avater.png" },
        { name: "Herbs for Health", image: "/user-avater.png" },
        { name: "Remedy Depression", image: "/user-avater.png" },
        { name: "AI Solution to Cancer", image: "/user-avater.png" },
    ];

    const Join = async (id) => {
        setGroupLoading(true);

        try {
            const response = await put(`/Community/${id}/join-community`);
            if (response.statusCode === 200) {
                toast.success("You have successfully Followed the community");
            }
            setGroupLoading(false);
        } catch (error) {
            setGroupLoading(false);
            toast.error("Error joining community");
            console.error("Error joining community:", error);
        }
    };


    return (
        <div className="community-groups-container">
            {/* User Greeting */}
            {/* <div className="flex space-between">
                <div className="profile-section">
                    <img
                        src="/user-avater.png"
                        alt="User Profile"
                        className="profile-img"
                    />
                    <div>
                        <h2>Good morning!</h2>
                        <p>Jessica Williams</p>
                    </div>
                </div>
                <div className="w-60">
                    <div className="search-container float-right w-40">
                        <input
                            type="text"
                            placeholder="Search for Groups"
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <span className="filter-icon">🔍</span>
                    </div>
                </div>
            </div> */}

            {/* Community Filters */}
            <div className="filter-buttons">
                <button className="filter-btn active">All</button>
                <button className="filter-btn">Fitness</button>
                <button className="filter-btn">Wellness</button>
                <button className="filter-btn">Nutrition</button>
                <button className="filter-btn">Mental Health</button>
                <button className="filter-btn">Men’s Health</button>
                <button className="filter-btn">Women’s Health</button>
            </div>

            {/* Groups List */}
            <div className="group-list">
                {data?.map((group, index) => (
                    <div className="group-item" key={index}>
                        <img src={group.pictureUrl || '/user-avater.png'} alt={group.name} className="group-image" />
                        <div className="group-info">
                            <p className="group-title">{group.name}</p>
                            <p className="group-meta">Public. {group?.communityMembers.length} members. 6 posts a year</p>
                        </div>
                        <button onClick={(e) => Join(group?.id)} className="submit-btn w-20">Follow</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CommunitySearch;
